var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-html-panel',{staticStyle:{"background-color":"#ffffff"},attrs:{"url":_vm.url},on:{"update:url":function($event){_vm.url=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }